export const DEFAULT_VIEW_ORIGIN = [42, -93];
export const DEFAULT_ZOOM = 16;
export const MAX_ZOOM = 18;
